const ticker = [
  "一线综艺口碑两极发酵",
  "顶流团巡演阵容官宣",
  "赛事爆冷出局复盘",
  "老牌综艺停播传闻",
  "新旗舰机发布猜想",
  "影后新作求定档",
  "社交APP改版争议",
  "健身房避雷维权升温",
  "高校毕业典礼名场面",
  "选秀翻红选手考古",
];

export default function TrendingTicker() {
  const list = [...ticker, ...ticker];
  return (
    <div className="relative flex items-stretch overflow-hidden border-y border-background-200 bg-background-100 py-0">
      <div className="z-10 flex shrink-0 items-center gap-2 bg-foreground-950 px-4 md:px-6 py-3 text-background-50">
        <i className="ri-flashlight-fill text-accent-400 w-4 h-4 flex items-center justify-center"></i>
        <span className="text-xs font-semibold whitespace-nowrap">实时热榜</span>
      </div>
      <div className="relative flex flex-1 items-center overflow-hidden">
        <div className="flex min-w-full shrink-0 items-center gap-8 animate-marquee whitespace-nowrap px-6">
          {list.map((t, i) => (
            <a key={i} href="#ranking" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 cursor-pointer transition-colors">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-400"></span>
              <span className="font-medium">{t}</span>
              <i className="ri-arrow-up-line text-xs text-accent-600 w-3 h-3 flex items-center justify-center"></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}